import { TranslationObject } from '@ngx-translate/core';

const nl: TranslationObject = {
  nl: 'Dutch',
  en: 'Engels',
  app: {
    title: 'Pre-startup veiligheidsevaluatie',
    forms: {
      ok: 'Ok',
      cancel: 'Annuleer',
      create: 'Maak aan',
      continue: 'Doorgaan',
      selectAll: 'Selecteer Alles',
      save: 'Opslaan',
      labels: {
        businessUnit: 'Bedrijfseenheid',
        placeholderBusinessUnit: 'Selecteer een bedrijfseenheid',
        organization: 'Organisatie',
        placeholderOrganization: 'Selecteer een organisatie',
        user: 'Gebruiker',
        name: 'Naam',
        description: 'Beschrijving',
        displayRichEditor: 'Geavanceerde editor weergeven',
        statusOptions: {
          draft: 'Draft',
          initiated: 'Initiated',
          inProgress: 'In Progress',
          completed: 'Completed',
          pendingApproval: 'Pending Approval',
          approved: 'Approved',
          closed: 'Closed',
        },
        placeHolderDescription: 'Voer een beschrijving in',
        placeHolderReviewType: 'Selecteer een beoordelingssoort',
        mandatory: 'Verplicht',
        isActive: 'Actief',
      },
      categories: {
        placeholders: {
          categoryName: 'Categorienaam',
        },
      },
      unsavedChangesWarning:
        'Er zijn niet-opgeslagen wijzigingen gedetecteerd. Als u deze pagina verlaat, gaan de door u aangebrachte wijzigingen verloren.<br>Wilt u doorgaan?',
      validation: {
        required: '{{controlName}} is verplicht',
        invalidEmail: 'Voer een geldig e-mailadres in',
      },
    },
    warnings: {
      removeOwnAdminRights: 'U heeft uw beheerdersrechten verwijderd. Vernieuw de webpagina om storingen te voorkomen.',

      removeOwnAccess: 'U heeft uw toegang verwijderd. Vernieuw de webpagina om storingen te voorkomen.',
    },
  },
  header: {
    support: 'Ondersteuning',
    userGuide: 'Gebruikershandleiding',
  },
  navigation: {
    pssrs: '{{pssrTitle}}s',
    projects: 'Projecten',
    actionsItems: 'Actiepunten',
    administration: 'Administratie',
    hierarchyManagement: 'Hiërarchiebeheer',
    businessUnits: 'Bedrijfseenheden',
    organizations: 'Organisaties',
    facilityHierarchy: 'Faciliteithiërarchie',
    accessManagement: 'Toegangsbeheer',
    organizationUsers: 'Gebruikers',
    buAdmins: 'Gebruikersbeheerders',
    userGroups: 'Actiepuntgebruikersgroepen',
    systemAdmins: 'Systeembeheerders',
    pssrConfiguration: 'PSSR Configuration',
    templates: 'PSSR-controlelijsten',
    categories: 'Bedrijfseenheid categorieën',
  },
  functionalReviewList: {
    title: 'Functionele Review',
    noFunctionalReview: 'Geen functionele review',
    id: 'ID',
    code: 'Code',
    question: 'Vraag',
    answer: 'Antwoord',
    comment: 'Opmerking',
    updatedBy: 'Bijgewerkt door',
    updatedDate: 'Datum van bijwerking',
    createNewFunctionalReview: 'nieuwe functionele review maken',
    reviewType: 'Beoordelingstype',
    addQuestion: 'Vraag Toevoegen',
    description: 'Beschrijving',
    subSection: 'Subsectie',
    clearAnswer: 'Antwoord Wissen',
    deleteQuestion: 'Vraag Verwijderen',
    deleteQuestionTitle: 'Vraag Verwijderen',
    confirmDeleteQuestion:
      '<span>Weet u zeker dat u deze vraag wilt verwijderen?</span><br><br><span><b>Vraag:</b> {{ description }}</span>',
    generateReport: 'Rapport Genereren',
    completeReview: 'Review Voltooien',
    generateSuccessMessage: 'Rapport succesvol gegenereerd',
    reviewSuccessMessage: 'Functionele review succesvol voltooid',
  },
  admin: {
    sysAdminList: {
      title: 'Systeembeheerders',
      addSysAdmin: 'systeembeheerder toevoegen',
      fullName: 'volledige naam',
      disabled: 'Uitgeschakeld',
      email: 'e-mail',
      dialogs: {
        removeAccessHeader: 'Bevestiging',
        removeAccessMessage:
          'Weet u zeker dat u de systeembeheerderstoegang voor [{{firstName}} {{lastName}}] wilt verwijderen?',
      },
    },
    businessUnitLists: {
      title: 'Bedrijfseenheden',
      addBusinessUnit: 'Bedrijfseenheid toevoegen',
      tableTitle: 'Bedrijfseenheid',
    },
    businessUnitCreate: {
      title: 'Bedrijfseenheid aanmaken',
    },
    businessUnitEdit: {
      title: 'Bewerk Bedrijfseenheid',
    },
    businessUnitForm: {
      sections: {
        supportInformation: {
          titleSupport: 'Ondersteuningsinformatie',
          name: 'Naam',
          businessUnitSupportInfo: 'Ondersteuningsinformatie Bedrijfseenheid',
          businessUnitSupportInfoDescription: 'Deze informatie wordt weergegeven op de ondersteuningspagina',
          displayRichEditor: 'rijke editor weergeven',
        },
        approvalForAccess: {
          titleApproval: 'Goedkeuring voor Toegang',
          userNeedsBuAdmin: 'Gebruiker heeft een bedrijfseenheidbeheerder nodig om toegang te verlenen',
          userGetsInstantAccess: 'Gebruiker krijgt onmiddellijk toegang',
        },
        labels: {
          titleLabels: 'Labels',
          hierarchyLabel1: 'Hiërarchielabel 1',
          hierarchyLabel2: 'Hiërarchielabel 2',
          hierarchyLabel3: 'Hiërarchielabel 3',
          pssrLabel: 'PSSR Label',
          organizationLabel: 'Organisatielabel',
          eventNameLabel: 'Gebeurtenisnaamlabel',
          p3: 'P3',
          p4: 'P4',
          p5: 'P5',
          placeholderDefault: 'standaardwaarde is \'project\'',
          show: 'tonen',
        },
        pssrConfigurations: {
          titleConfigurations: 'PSSR Configuraties',
          stagnantPssrInterval: 'Stagnant PSSR Interval',
          instructions: 'Instructies',
          instructionsDescription: 'Algemene stagnante instructies voor PSSR',
          showProject: 'Wilt u Project weergeven?',
          projectDisplayType: 'Hoe wilt u Project weergeven?',
          dropdown: 'vervolgkeuzelijst',
          input: 'invoer',
          showKms:
            'Wilt u KMS weergeven? Er wordt een knop "ophalen van KMS" weergegeven bij het maken van een nieuwe PSSR.',
          showQaqcModule: 'Wilt u de QAQC-module op Project weergeven? Vereist dat project is ingeschakeld.',
          showWetSignatureApproval:
            'Wilt u een natte handtekening van de PSSR toestaan? Dit stelt de Operations Rep in staat om de PSSR in afwachtende goedkeuringsstatus goed te keuren. De knop zegt "goedkeuren met natte handtekening".',
          pssrTypesToShow: 'Welke PSSR-types wilt u weergeven?',
          ccc: 'CCC',
          factory: 'Fabriek',
          moc: 'MOC',
          nonMoc: 'NIET-MOC',
          orr: 'ORR',
          pfsr: 'PFSR',
          test: 'Test',
          showNaResponse:
            'Wilt u gebruikers toestaan om N/A te antwoorden? Als u nee selecteert, is een opmerking of actie-item vereist om als voltooid te worden beschouwd.',
          sendScheduledEmail:
            'Wilt u elke maandag om 8:00 uur CST een geplande e-mail sturen naar gebruikers met openstaande actie-items?',
          showConstructionComplete:
            'Wilt u het Certificaat van Voltooide Bouw (CCC) weergeven voor sommige koppen/titels/labels?',
          showOperationReadiness:
            'Wilt u de Operationele Gereedheidsbeoordeling (ORR) weergeven voor sommige koppen/titels/labels?',
          showVerbalApproval:
            'Wilt u mondelinge goedkeuring weergeven? Dit toont een invoer in de mobiele app om handmatig te schrijven wie goedkeurt. Dit veroorzaakt geen actie en kan worden gedaan door de leider of goedkeurder.',
          allowLeadToDelete:
            'Wilt u de leider toestaan om vragen te verwijderen voor een PSSR in concept- of gelanceerde status?',
          allowTeamMemberActions:
            'Wilt u elk teamlid toestaan om vragen te beantwoorden, vragen te ondertekenen en actie-items aan te maken tot goedkeuring?',
          restrictMocWo:
            'Wilt u het MOCWO-projectnummer beperken? Als u "ja" selecteert, zijn MOC en WO vereist om een PSSR aan te maken.',
          allowLeadsToShare:
            'Wilt u Leads toestaan het apparaat te delen met goedkeurders? Als u "ja" selecteert, kan de leider het apparaat delen met de goedkeurder als de goedkeurder aanwezig is om te ondertekenen.',
          requireFinalApprovalBeforeInitiation:
            'Wilt u definitieve goedkeuring vereisen vóór initiatie? Als "ja", moet de PSSR een definitieve goedkeurder hebben om te starten.',
          allowFinalApproverNotifications: 'Wilt u de definitieve goedkeurder toestaan alle meldingen te ontvangen?',
          allowFinalApproverSubmit: 'Wilt u de definitieve goedkeurder toestaan om in te dienen voor goedkeuring?',
          allowMultiplesApprovers: 'Wilt u meerdere goedkeurders toestaan?',
          ShowSectionsCollapsed: 'Wilt u PSSR-secties ingeklapt weergeven tijdens bewerken?',
          requireActionItemDueDate: 'Wilt u een vervaldatum vereisen voor actie-items?',
          limitAccessToAIOwner:
            'Wilt u de eigenaar of toegewezene van het actie-item beperken van het wijzigen van de beschrijving, het wijzigen van de vervaldatum of het verwijderen van het actie-item?',
        },
        actionItemConfigurations: {
          titleItemConfigurations: 'Actie-item Configuraties',
          sendToMoc: 'Wilt u actie-items naar MOC sturen?',
          p3: 'P3',
          p4: 'P4',
          allowTeamLeadAttach:
            'Wilt u de teamleider toestaan een actie-item bij te voegen en te wijzigen? Als u "ja" selecteert, kunnen leiders alleen bestanden, toegewezene, status en opmerking toevoegen na afwachtende goedkeuring.',
          allowActionItemOwnerAttach:
            'Wilt u de eigenaar van het actie-item toestaan om bij te voegen in elke status zolang de PSSR niet gesloten is?',
        },
      },
    },
  },
  user: {
    requestAccess: {
      title: 'Niet geregistreerd',
      forms: {
        submit: 'Verzoek Toegang',
      },
      dialogTitle: 'Verzoek Toegang',
      dialogSubtitle:
        'Je staat op het punt om toegang aan te vragen voor <strong>{{Name}}</strong>, wil je verder gaan?',
      reloadWarning:
        'Als je deze pagina bezoekt maar al toegang hebt, klik dan op de volgende link om opnieuw te laden. Neem anders contact op met de ondersteuning.',
      reload: 'Opnieuw laden',
    },
    pendingAccess: {
      title: 'Hi, je Verzoek voor Toegang is in behandeling',
      reloadWarning:
        'Als je deze pagina bezoekt maar al toegang hebt, klik dan op de volgende link om opnieuw te laden. Neem anders contact op met de ondersteuning.',
      reload: 'Opnieuw laden',
    },
  },
  footer: {
    text: 'Chevron Corporation. Alle rechten voorbehouden.',
  },
  checklist: {
    title: 'PSSR Checklist',
    create: 'nieuwe maken',
    hideCode: 'code verbergen',
    code: 'Code',
    name: 'Checklistnaam',
    emptyHierarchyChildrenMessage:
      '<p>Er zijn geen <strong>{{childLabel}}</strong> beschikbaar voor deze <strong>{{parentLabel}}</strong>.</p><p>Voeg een nieuwe <strong>{{childLabel}}</strong> toe om te beginnen.</p>',
    edit: 'bewerken',
    manage: 'beheren',
    delete: 'verwijderen',
    defaultWalkthroughDisclaimer: 'Standaard handtekening disclaimer voor doorloop',
    defaultSummaryDisclaimer: 'Standaard handtekening disclaimer voor samenvatting',
    displayRichEditor: 'uitgebreide editor weergeven',
    sampleText: 'voorbeeldtekst',
    dialogs: {
      removeAccessHeader: 'Bevestiging',
      removeAccessMessage: 'Weet u zeker dat u [{{description}}] wilt verwijderen?',
    },
    confirmDelete:
      '<span>Sind Sie sicher, dass Sie diese Checkliste löschen möchten?</span><br><br><span>Name: {{ name }}<br>Beschreibung: {{ description }}</span>',
    noChecklists: 'Geen checklists beschikbaar.',
    titleCreate: 'Checkliste erstellen',
    createNew: 'Neu erstellen',
    selectPlaceholder: 'Wählen Sie eine Option aus...',
    titleEdit: 'Checkliste bearbeiten',
    titleDelete: 'Checkliste löschen',
    deletedSuccessfully: 'Checkliste erfolgreich gelöscht',
    importChecklist: 'Checkliste importieren',
    importChecklistTitle: 'Checkliste importieren nach ',
    selectChecklistType: 'Checklistentyp auswählen',
    confirm: 'Bestätigen',
    importSuccessMessage: 'Checkliste erfolgreich importiert',
  },
  common: {
    yes: 'Ja',
    no: 'Nein',
    na: 'N.v.t.',
    save: 'Speichern',
    saving: 'Opslaan...',
    businessUnit: 'Geschäftseinheit',
    forbidActionErrorMessage: 'De gebruiker is niet gemachtigd om deze actie uit te voeren.',
    name: 'Name',
    code: 'Code',
    cancel: 'Stornieren',
    confirm: 'Bevestigen',
    back: 'Terug',
    genericErrorMessage: 'Er is een onverwachte fout opgetreden. Probeer het later opnieuw.',
    errorOccurred: 'Er is een fout opgetreden. Probeer het opnieuw.',
    savedSuccessfully: 'Succesvol opgeslagen',
    delete: 'Löschen',
    deletedSuccessfully: 'Erfolgreich gelöscht',
    edit: 'Bearbeiten',
    leaveWithOutSaving: 'Verlassen ohne zu speichern',
    language: 'Taal',
    month: 'Maand',
    months: 'Maanden',
    loading: 'Laden...',
    all: 'Alle',
    recordAlreadyExists: 'Record bestaat al',
    recordCreatedSuccessfully: 'Record succesvol aangemaakt',
    createdSuccessfully: 'Met succes aangemaakt',
  },

  checklistManage: {
    title: 'Beheer Inhoud van [{{ description }}]',
    sectionsTitle: 'Onderdelen',
    addSectionAction: 'sectie toevoegen',
    mandatoryLabel: 'Verplicht',
    createNewSubsectionAction: 'sectie toevoegen',
    emptySubSectionsMessage: `<p>Er is geen inhoud beschikbaar voor deze sectie.</p>
      <p>Voeg alstublieft een subsectie toe om te beginnen.</p>`,
    itemCodeTableHeader: 'code',
    itemDescriptionTableHeader: 'Beschrijving',
    createNewItemAction: 'Vraag Toevoegen',
    createSectionHeader: 'Maak Nieuw Onderdeel aan',
    editSectionHeader: 'Onderdeel Bewerken',
    confirmDeleteSection: 'Weet je zeker dat je de sectie <strong>{{description}}</strong> wilt verwijderen?',
    createSubSectionHeader: 'Maak Nieuwe Subsectie aan',
    editSubSectionHeader: 'Bewerk Sub sectie',
    createChecklistItemTitle: 'Checklijstitem maken',
    editChecklistItemTitle: 'Checklijstitem bewerken',
    ShouldAddCommentToQuestion: 'De gebruiker moet een opmerking toevoegen aan elke vraag die met N/A is beantwoord',
    autoGenerateCodeLabel: 'Code automatisch genereren',
    autoGenerateCodeplaceholder: 'De code wordt automatisch gegenereerd',
    autoGenerateCodeInfo: 'Automatische generatie is geactiveerd, het veld wordt automatisch ingevuld.',
    deleteChecklistItemTitle: 'Checklijstitem verwijderen',
    confirmDeleteChecklistItem:
      '<span>Weet u zeker dat u dit checklijstitem wilt verwijderen?</span><br><br><span><b>Code:</b> {{ name }}<br><b>Beschrijving:</b> {{ description }}</span>',
    createQuestionTitle: 'Vraag maken',
    deleteQuestionTitle: 'Vraag verwijderen',
    confirmDeleteQuestion:
      '<span>Weet u zeker dat u deze vraag wilt verwijderen?</span><br><br><span><b>Code:</b> {{ name }}<br><b>Beschrijving:</b> {{ description }}</span>',
    confirmDeleteSubSection: 'Weet je zeker dat je de subsectie <strong>{{description}}</strong> wilt verwijderen?',
    deleteSectionHeader: 'Onderdeel Verwijderen',
    deleteSubSectionHeader: 'Subsectie Verwijderen',
    editQuestionTitle: 'Vraag bewerken',
    sectionTypeLabel: 'Sectietype',
    sectionTypePlaceholder: 'Selecteer een sectietype',
    subSectionNameLabel: 'Subsectienaam',
    itemTypeLabel: 'Type',
    itemTypePlaceholder: 'selecteer één',
    codePlaceholder: 'Voer code in',
    duplicateCodeError: 'Deze code wordt al gebruikt in een andere sectie.',
    displayRichEditorLabel: 'Rijke editor weergeven',
    requireCommentForNA: 'Wilt u een opmerking vereisen voor een N/A-vraag?',
  },
  paginator: {
    previous: 'Vorige',
    next: 'Volgende',
    currentPageReport: '{{currentInitialRow}} - {{currentLastRow}} van {{totalRecords}}',
  },
  usersList: {
    title: 'Gebruikers',
    forms: {
      displayInactiveUsers: 'inactieve gebruikers weergeven',
      search: 'Zoeken',
    },
    actions: {
      addNewUser: 'Nieuwe gebruiker toevoegen',
      grantAccess: 'toegang verlenen',
      reimportAllSharedUsers: 'Alle gedeelde gebruikers opnieuw importeren',
    },
    table: {
      fullName: 'volledige naam',
      email: 'e-mail',
      admin: 'beheerder',
      type: 'type',
    },
    noUsers: 'Geen gebruikers beschikbaar',

    dialogs: {
      removeAccessHeader: 'Bevestiging',
      removeAccessMessage: 'Weet u zeker dat u de toegang wilt verwijderen voor: [{{fullName}}]?',
      addUserHeader: 'Nieuwe gebruiker toevoegen',
      editUserHeader: 'Gebruiker bewerken',
      reimportSharedUsersHeader: 'Alle gedeelde gebruikers opnieuw importeren',
      reimportSharedUsersMessage:
        'U staat op het punt de configuratie van alle gedeelde gebruikers bij te werken.<br> Deze bewerking kan enkele minuten duren.',
    },
    messages: {
      importSharedUsersFailed: 'Import mislukt',
      importSharedUsersIncompleted: 'Import onvolledig',
      importSharedUsersCompleted: 'Import voltooid in: {{ minutes }} min',
      pleaseWaitUntilProcessEnds:
        'Wacht tot het importproces is voltooid. Sluit deze pagina niet af en navigeer niet weg.',
      importInProgress: 'Het importeren is bezig. Wacht tot het klaar is voordat u de pagina sluit.',
      calculatingProgress: 'Voortgang wordt berekend...',
    },
    labels: {
      imported: 'Geïmporteerd',
      notFound: 'Niet gevonden',
      errors: 'Fouten',
      total: 'Totaal',
    },
  },
  actionItems: {
    title: 'Actie-items',
    addActionItem: 'actie-item toevoegen',
    noActionItems: 'Geen actie-items beschikbaar',
    canOnlyPerformAttachments:
      'U kunt alleen bestandsbijlagen beheren. Andere actie-item eigenschappen kunnen niet worden bewerkt.',
    actionTitle: 'Titel',
    assignee: 'Toegewezen persoon',
    date: 'Datum',
    dueDate: 'Vervaldatum',
    category: 'Categorie',
    primaryCategory: 'Primaire categorie',
    secondaryCategory: 'Secundaire categorie',
    subcategory: 'Subcategorie',
    id: 'ID',
    comment: 'Opmerking',
    editComment: 'Opmerking bewerken',
    commentRequiredWhenClosed: 'Opmerking is vereist wanneer de status is ingesteld op Gesloten',
    priority: 'Prioriteit',
    assignTo: 'Toewijzen aan',
    pssrCccMembers: '{{pssrTitle}} leden',
    chevronDirectory: 'Chevron directory',
    userGroup: 'Gebruikersgroep',
    other: 'Ander',
    status: 'Status',
    statusNames: {
      Open: 'Open',
      Closed: 'Gesloten',
      Cancel: 'Geannuleerd',
      Rejected: 'Afgewezen',
    },
    createdBy: 'Aangemaakt door',
    updatedDate: 'Bijgewerkte datum',
    updatedBy: 'Bijgewerkt door',
    selectOne: 'Selecteer een...',
    typeNameOrEmail: 'Typ naam of e-mail...',
    inactive: 'Inactief',
    reopen: 'Heropenen',
    reject: 'Afwijzen',
    rejectReason: 'Reden van Afwijzing',
    rejectReasonPlaceholder: 'Voer reden van afwijzing in',
    timeCaptured: 'Tijd Vastgelegd',
    attachments: 'Bijlagen',
    pssrFiles: 'PSSR-bestanden',
    links: 'Links',
    fileUpload: 'Bestand uploaden',
    attachFiles: 'Bijlagen (docs, afbeeldingen, etc.)',
    fileTooLarge: 'Bestand \'{{name}}\' overschrijdt de maximaal toegestane grootte van {{max}}.',
    invalidFileFormat: 'Bestand \'{{name}}\' heeft een niet-ondersteund formaat.',
    duplicateFile: 'Bestand \'{{name}}\' is al toegevoegd.',
    linkPlaceholder: 'www.voorbeeld.com',
    dialogs: {
      configureActionItem: 'Configureer Actiepunt',
      configureComment: 'Opmerking',
      deleteActionItemHeader: 'Wis Actiepunt',
      deleteActionItemMessage: 'Weet je zeker dat je deze actie wilt uitvoeren?',
      rejectActionItemHeader: 'Actiepunt Afwijzen',
      confirmPriorityChangeHeader: 'Prioriteitswijziging Bevestigen',
      confirmPriorityChangeMessage: 'Weet u zeker dat u de prioriteit van dit actie-item wilt wijzigen?',
      deleteAttachmentHeader: 'Bijlage Verwijderen',
      deleteAttachmentMessage: 'Weet u zeker dat u deze bijlage wilt verwijderen?',
    },
    messages: {
      deleteSuccess: 'Actiepunt succesvol verwijderd',
      reopenSuccess: 'Actiepunt succesvol heropend',
      rejectSuccess: 'Actiepunt succesvol afgewezen',
      rejectReasonRequired: 'Reden van afwijzing is vereist',
      confirmReject: 'Weet je zeker dat je dit actiepunt wilt afwijzen? Het zal {{action}}.',
      confirmRejectP4: 'Weet je zeker dat je dit actiepunt wilt afwijzen?',
      returnToTeamLead: 'terug naar Teamleider',
      confirmReopen: 'Weet je zeker dat je dit actiepunt wilt heropenen?',
    },
  },
  actionItemsList: {
    title: 'Actiepunten',
    sections: {
      location: 'Locatie',
      pssr: 'PSSR',
      actionItem: 'Actiepunt',
    },
    fields: {
      area: 'Gebied',
      facilityOperationTeam: 'Faciliteitoperatieteam',
      facility: 'Faciliteit',
      titleStatus: 'Titelstatus',
      type: 'Type',
      title: 'Titel',
      project: 'Project',
      template: 'Sjabloon',
      leadFinalApprover: 'Leider/Eindgoedkeurder',
      showOnlyDeletedPssr: 'Toon Alleen Verwijderde PSSR',
      status: 'Status',
      priority: 'Prioriteit',
      assignedTo: 'Toegewezen aan',
      autoLoadImages: 'Afbeeldingen Automatisch Laden',
    },
    placeholders: {
      selectOne: 'selecteer een',
      sampleText: 'voorbeeldtekst',
      no: 'Selecteer Nee',
    },
    priorityDescriptions: {
      p3: 'Item moet voltooid zijn voor opstart',
      p4: 'Item wordt voltooid na opstart',
      p5: 'Item moet voltooid zijn voor opstart',
    },
    priorityLegend: {
      title: 'Prioriteiten van Actie-items',
    },
    actions: {
      clearFilter: 'filter wissen',
      exportExcel: 'exporteer excel',
      noDataToExport: 'Geen actie-items om te exporteren',
    },
    imageAltText: 'Actie-item Afbeelding',
    pssrTeamLead: 'PSSR Teamleider',
    finalApprover: 'Eindgoedkeurder',
    subsection: 'Subsectie',
    code: 'Code',
    question: 'Vraag',
    answer: 'Antwoord',
    noData: 'Geen actiepunten beschikbaar',
    noDataFound: 'Geen actiepunten gevonden voor de geselecteerde filters',
  },
  responseSignature: {
    signedBy: 'Ondertekend Door',
    signedOn: 'Ondertekend Op',
    name: 'Naam',
    dateCaptured: 'Datum Vastgelegd',
    sign: 'Ondertekenen',
    finalApproverLabel: 'Eindgoedkeurder',
    dialogs: {
      deleteHeader: 'Handtekening verwijderen',
      deleteMessage: 'U staat op het punt de handtekening te verwijderen, selecteer bevestigen om door te gaan',
      cancel: 'annuleren',
      delete: 'verwijderen',
    },
  },
  comments: {
    title: 'Commentaar',
    addComment: 'commentaar toevoegen',
    dialogs: {
      configureComment: 'Opmerking',

      deleteCommentHeader: 'Commentaar verwijderen',
      deleteCommentMessage: 'Weet je zeker dat je deze actie wilt uitvoeren?',
    },
    comment: 'Opmerking',
  },
  userType: {
    Chevron: 'Chevron',
    External: 'Derde (extern)',
    Shared: 'Gedeeld',
  },
  areas: {
    title: 'Gebied',
    showDeletedItems: 'Verwijderde items tonen',
    areaListTitle: 'Gebiedenlijst',
    createFacilityOperationTeam: 'Nieuw facilitair operationeel team aanmaken',
    createFacility: 'Nieuwe faciliteit aanmaken',
    restore: 'Herstellen',
    emptySubAreaMessage:
      '<p>Er is geen inhoud beschikbaar voor dit gebied.</p><p>Voeg een nieuw facilitair operationeel team toe om te beginnen.</p>',
    emptyHierarchyChildrenMessage:
      '<p>Er zijn geen <strong>{{childLabel}}</strong> beschikbaar voor deze <strong>{{parentLabel}}</strong>.</p><p>Voeg een nieuwe <strong>{{childLabel}}</strong> toe om te beginnen.</p>',
    emptyAreaMessage:
      '<p>Er is geen inhoud beschikbaar voor deze bedrijfseenheid.</p><p>Voeg een nieuw gebied toe om te beginnen.</p>',
    subareaTitle: 'Facilitair operationeel team',
    facilityTitle: 'Faciliteit',
    removeConfirmationHeader: 'Bevestiging',
    confirmDeleteArea: 'Weet u zeker dat u het gebied <strong>{{description}}</strong> wilt verwijderen?',
    confirmDeleteSubarea:
      'Weet u zeker dat u het facilitair operationeel team <strong>{{description}}</strong> wilt verwijderen?',
    confirmDeleteFacility: 'Weet u zeker dat u de faciliteit <strong>{{description}}</strong> wilt verwijderen?',
    restoredSuccessfully: 'Succesvol hersteld',
  },
  pssrImport: {
    title: 'MOC Importeren',
    sections: {
      import: 'Importeren',
    },
    forms: {
      labels: {
        application: 'Applicatie',
        pssrId: 'ID',
        mocId: 'MOC ID',
        mocName: 'MOC Naam',
      },
      placeholders: {
        application: 'selecteer een optie',
        pssrId: 'Voer MOC ID in',
        mocName: 'Automatisch ingevuld vanuit iMOC',
      },
      validation: {
        mocIdRequired: 'MOC ID is verplicht',
        applicationRequired: 'Applicatie is verplicht',
      },
    },
    actions: {
      add: 'Toevoegen',
      addMoc: 'MOC Toevoegen',
      importAll: 'Alles Importeren',
      createPssr: 'PSSR aanmaken',
      searchMoc: 'MOC zoeken',
      importMocCreatePssr: 'MOC importeren en PSSR aanmaken',
    },
    table: {
      id: 'ID',
      pssrId: 'PSSR ID',
      name: 'Naam',
      status: 'Status',
    },
    summary: {
      records: 'Records',
      imported: 'Geïmporteerd',
      errors: 'Fouten',
    },
    status: {
      pending: 'In behandeling',
      inProgress: 'Bezig',
      imported: 'Geïmporteerd',
      warning: 'Waarschuwing',
      error: 'Fout',
    },
    messages: {
      alreadyInList: 'PSSR ID staat al in de importlijst.',
      pssrNotFound: 'PSSR niet gevonden.',
    },
  },
  pssrCreate: {
    title: 'PSSR Maken',
    sections: {
      generalInformation: 'Algemene Informatie',
      location: 'Locatie',
      details: 'Details',
      instructions: 'Instructies',
    },
    forms: {
      labels: {
        title: 'Titel',
        moc: 'MOC',
        wo: 'WO',
        description: 'Beschrijving',
        area: 'Gebied',
        facilityOperationTeam: 'Faciliteit Operatieteam',
        facility: 'Faciliteit',
        project: 'Project',
        template: 'Sjabloon',
        type: 'Type',
        organization: 'Organisatie',
        subArea: 'Subgebied',
        includeProjectTeam: 'Projectteamleden opnemen',
      },
      placeholders: {
        title: 'voorbeeldtekst',
        moc: 'voorbeeldtekst',
        wo: 'voorbeeldtekst',
        description: 'Voer beschrijving in',
        area: 'selecteer één',
        facilityOperationTeam: 'selecteer één',
        facility: 'selecteer één',
        project: 'selecteer één',
        template: 'selecteer één',
        type: 'selecteer één',
        subArea: 'selecteer één',
      },
      validation: {
        titleRequired: 'Titel is verplicht',
        mocRequired: 'MOC is verplicht',
        woRequired: 'WO is verplicht',
        businessUnitRequired: 'Business Unit is verplicht',
        organizationRequired: 'Organisatie is verplicht',
        areaRequired: 'Gebied is verplicht',
        facilityOperationTeamRequired: 'Faciliteit Operatieteam is verplicht',
        facilityRequired: 'Faciliteit is verplicht',
        projectRequired: 'Project is verplicht',
        templateRequired: 'Sjabloon is verplicht',
        typeRequired: 'Type is verplicht',
        requiredFieldsMessage: 'Opmerking: Vul de velden in die als verplicht zijn gemarkeerd. Klik op Opslaan.',
      },
      templateChangeConfirmTitle: 'Sjabloon wijzigen',
      templateChangeConfirmMessage:
        'Door het sjabloon te wijzigen worden de PSSR-secties bijgewerkt. Weet u zeker dat u het sjabloon wilt wijzigen?',
    },
    actions: {
      create: 'creëren',
      pullFromKMS: 'Haal uit KMS',
    },
    successMessage: 'PSSR succesvol aangemaakt',
  },
  pssrKms: {
    title: 'PSSR van KMS',
    sections: {
      generalInformation: 'Algemene Informatie',
      pssrInformation: 'PSSR Informatie',
      location: 'Locatie',
      details: 'Details',
    },
    kmsInstruction:
      'Zoek naar een specifiek MOC-nummer of filter de lijst op status en paginagrootte om gegevens uit KMS te importeren.',
    searchMOCNumber: 'Zoek MOC Nummer',
    mocPattern: 'bijv., MOC-2024-123',
    invalidMOCFormat: 'Ongeldig MOC-formaat. Voorbeeld: MOC-2024-123',
    search: 'Zoeken',
    filterByStatus: 'Filter KMS Lijst op Status',
    filterPageSize: 'Filter Aantal Geretourneerde KMS Items',
    selectFromList: 'Selecteer uit KMS MOC Lijst',
    selectKMSItems: 'Selecteer KMS items',
    createNew: 'Nieuwe Aanmaken',
    enterName: 'Voer naam in',
    add: 'Toevoegen',
    enterProjectNumber: 'Voer projectnummer in',
    selectQAQCEvent: 'Selecteer QAQC gebeurtenis',
    selectFromQAQC: 'Selecteer uit QAQC',
    milestones: 'Mijlpalen',
    workOrders: 'Werkopdrachten',
    selectMilestone: 'Selecteer mijlpaal',
    selectWorkOrder: 'Selecteer werkopdracht',
    milestoneWorkOrders: 'Mijlpaal Werkopdrachten',
    note: 'Opmerking',
    fillRequiredFields: 'Vul de velden in die als verplicht zijn gemarkeerd',
    generatePSSRs: 'Genereer PSSRs',
    successMessage: 'PSSR van KMS succesvol aangemaakt',
    multipleSuccessMessage: 'Meerdere PSSRs van KMS succesvol aangemaakt',
    loadingKMSItemsError: 'Fout bij het laden van KMS items. Probeer het opnieuw.',
    selectKMSItemsWarning: 'Selecteer ten minste één KMS item',
    kmsStatus: {
      draft: 'Concept',
      processActivated: 'Proces Geactiveerd',
      reviewInProgress: 'Beoordeling Bezig',
      implementationInProgressEdit: 'Implementatie Bezig Bewerken',
      changeRequestApproved: 'Wijzigingsverzoek Goedgekeurd',
      changeRequestDenied: 'Wijzigingsverzoek Geweigerd',
      implementationInProgress: 'Implementatie Bezig',
      readyToStartUp: 'Klaar om te Starten',
      completed: 'Voltooid',
      canceled: 'Geannuleerd',
      onHold: 'In Wacht',
    },
    businessUnit: 'Bedrijfseenheid',
    selectPlaceholder: 'Selecteer één',
  },
  pssrSubSections: {
    actions: {
      addQuestion: 'Vraag toevoegen',
    },
  },
  pssrDetails: {
    title: 'PSSR Details',
    pssrId: 'PSSR ID',
    sections: {
      generalInformation: 'Algemene Informatie',
      location: 'Locatie',
      details: 'Details',
      sectionsTitle: 'Secties',
      actionItems: 'Actie-items',
      comments: 'Opmerkingen',
      enableCustomOrderForSections: 'Aangepaste volgorde voor secties inschakelen',
      sectionsLegendTitle: 'Legenda van secties',
      hideCompletedQuestions: 'Voltooide vragen verbergen',
      saveSectionOrder: 'Sectievolgorde opslaan',
      confirmRemoveSectionTitle: 'Verwijder onderdeel',
      confirmRemoveSectionDescription: 'Weet je zeker dat je {{description}} wilt verwijderen?',
      sectionNameLabel: 'Sectienaam',
      sectionNamePlaceholder: 'Voer sectienaam in',
      editSectionName: 'Bewerk sectienaam',
      addMultipleSectionName: 'Meervoudige sectie toevoegen',
      validation: {
        sectionNameRequired: 'Sectienaam is verplicht',
        sectionNameDuplicated: 'Een sectie met deze naam bestaat al',
      },
      toast: {
        unableToCompleteOperation: 'Kan de bewerking niet voltooien',
        saveCompletedTitle: 'Opslaan voltooid',
        sectionsSortedSuccessfully: 'Secties zijn succesvol gesorteerd',
        loadSectionsError: 'Fout bij het laden van secties. Probeer het opnieuw.',
        userAlreadyAdded: 'Gebruiker al toegevoegd aan deze sectie',
        userAddedSuccessfully: 'Gebruiker succesvol toegevoegd',
        sectionAddedSuccessfully: 'Sectie succesvol toegevoegd',
        sectionUpdatedSuccessfully: 'Sectie succesvol bijgewerkt',
      },
      selectLead: 'Selecteer lead',
      section1Title: 'Sectie 1',
      legend: {
        defaultQuestionLabel: 'standaardvraag',
        defaultQuestionDescription: 'vraag die kan worden beantwoord met ja, nee of n.v.t.',
        optionalLabel: 'optioneel',
        optionalDescription: 'kan handmatig aan de PSSR worden toegevoegd',
        multipleLabel: 'meervoudig',
        multipleDescription: 'optioneel maar kan meerdere keren aan de PSSR worden toegevoegd',
        mandatoryLabel: 'verplicht',
      },
      instructions: 'Instructies',
      history: 'Geschiedenis van PSSR wijzigingen',
      attachments: 'PSSR Bijlagen',
    },
    subsections: {
      actionItemNeeded: 'Let op: Een actie-item is nodig om vragen te voltooien.',
    },
    questions: {
      code: 'Code',
      question: 'Vraag',
      answer: 'Antwoord',
      updatedBy: 'Bijgewerkt Door',
      updatedDate: 'Bijwerkdatum',
      clearAnswer: 'antwoord wissen',
      deleteQuestion: 'vraag verwijderen',
      answerUpdated: 'Antwoord succesvol bijgewerkt',
      answerCleared: 'Antwoord succesvol gewist',
      questionDeleted: 'Vraag succesvol verwijderd',
      confirmDeleteTitle: 'Vraag Verwijderen',
      confirmDeleteMessage: 'Weet je zeker dat je deze vraag wilt verwijderen: {{question}}?',
      validation: {
        actionItemIsNeeded: 'Een actie-item is nodig om de vraag te voltooien',
        commentIsNeeded: 'Een opmerking is nodig om de vraag te voltooien',
        signatureIsNeeded: 'Een handtekening is nodig om de vraag te voltooien',
        responseIsNeeded: 'Een antwoord is nodig om de vraag te voltooien',
        actionItemsClosedOrCancelledNeeded:
          'Gesloten of geannuleerde {{P3Label}}-actie-items zijn nodig om de vraag te voltooien',
      },
    },
    forms: {
      labels: {
        title: 'Titel',
        moc: 'MOC',
        wo: 'WO',
        description: 'Beschrijving',
        area: 'Gebied',
        facilityOperationTeam: 'Faciliteit Operatieteam',
        facility: 'Faciliteit',
        project: 'Project',
        template: 'Sjabloon',
        type: 'Type',
      },
      placeholders: {
        title: 'voorbeeldtekst',
        moc: 'voorbeeldtekst',
        wo: 'voorbeeldtekst',
        description: 'Voer beschrijving in',
        area: 'selecteer één',
        facilityOperationTeam: 'selecteer één',
        facility: 'selecteer één',
        project: 'selecteer één',
        template: 'selecteer één',
        type: 'selecteer één',
      },
      validation: {
        titleRequired: 'Titel is verplicht',
        businessUnitRequired: 'Business Unit is verplicht',
        organizationRequired: 'Organisatie is verplicht',
        areaRequired: 'Gebied is verplicht',
        facilityOperationTeamRequired: 'Faciliteit Operatieteam is verplicht',
        facilityRequired: 'Faciliteit is verplicht',
        templateRequired: 'Sjabloon is verplicht',
        typeRequired: 'Type is verplicht',
        requiredFieldsMessage: 'Opmerking: Vul de velden in die als verplicht zijn gemarkeerd. Klik op Opslaan.',
      },
      templateChangeConfirmTitle: 'Sjabloon wijzigen',
      templateChangeConfirmMessage:
        'Door het sjabloon te wijzigen worden de PSSR-secties bijgewerkt. Weet u zeker dat u het sjabloon wilt wijzigen?',
    },
    actions: {
      save: 'opslaan',
      saveGeneralInformation: 'algemene informatie opslaan',
      showFullHistory: 'volledige geschiedenis weergeven',
      showLessHistory: 'minder geschiedenis weergeven',
      attachFile: 'Bestand bijvoegen (documenten, afbeeldingen, psi-tekeningen, enz.)',
      attachFileButton: 'bestand bijvoegen',
      printToPdf: 'afdrukken naar pdf',
      sendEmailReminder: 'e-mailherinnering verzenden',
      importMocActionItems: 'moc-actieitems importeren',
      sendToMocStartup: 'verzenden naar moc-record voor opstartgoedkeuring',
      returnToTeamLead: 'terugsturen naar teamleider',
      start: 'start pssr',
      reject: 'afwijzen',
      delete: 'verwijderen',
      restorePssr: 'pssr herstellen',
      reopen: 'heropenen',
    },
    mocImportedHint: 'Deze PSSR is geïmporteerd. U kunt de id niet wijzigen',
    history: {
      reason: 'Reden',
      by: 'Door',
      draftCreated: 'Concept Gemaakt Op',
      initiated: 'Geïnitieerd Op',
      started: 'Gestart Op',
      completed: 'Voltooid Op',
      pendingApproval: 'Goedkeuring In Afwachting Op',
      verbalApproval: 'Mondelinge Goedkeuring Op',
      approved: 'Goedgekeurd Op',
      rejected: 'Afgewezen Op',
      restored: 'Hersteld Op',
      deleted: 'Verwijderd Op',
      closed: 'Gesloten Op',
    },
    successMessage: 'PSSR succesvol bijgewerkt',
    pdfDownloadSuccess: 'PDF succesvol gedownload',
    pssrDeletedSuccess: 'PSSR succesvol verwijderd',
    pssrReopenedSuccess: 'PSSR succesvol heropend',
    statusChangedSuccess: 'PSSR-status succesvol gewijzigd',
    pssrRejectedSuccess: 'PSSR succesvol afgewezen',
    pssrRestoredSuccess: 'PSSR succesvol hersteld',
    importMOCActionsSuccess: 'MOC-actieitems succesvol geïmporteerd',
    sendToMOCSuccess: 'Succesvol geüpload naar MOC',
    emailSentSuccess: 'E-mailherinnering succesvol verzonden',
    importMOCActionsNone: 'Geen MOC-actieitems om te importeren',
    lastSent: 'Laatst Verzonden',
    messages: {
      questionAdded: 'Vraag succesvol toegevoegd',
    },
    dialogs: {
      addQuestion: {
        descriptionLabel: 'Beschrijving',
        descriptionPlaceholder: 'Voer vraagbeschrijving in',
        descriptionRequired: 'Beschrijving is verplicht',
      },
    },
    rejectDialog: {
      title: 'PSSR Afwijzen',
      reasonLabel: 'Reden van Afwijzing',
      cancel: 'Annuleren',
      confirm: 'Afwijzen',
    },
    emailReminderDialog: {
      title: 'E-mailherinnering Verzenden',
      sendReminder: 'Herinnering Verzenden',
      sendMessage: 'Aangepast Bericht Verzenden',
      reminderInstructions:
        'Stuur herinnering naar toegewezenen voor alle geopende AIs. Wanneer PSSR in status In afwachting van goedkeuring is, ontvangen Goedkeurders een melding.',
      messageInstructions: 'Stuur een e-mailbericht naar alle PSSR-deelnemers',
      enterText: 'Voer uw bericht in...',
      cancel: 'Annuleren',
      confirm: 'Verzenden',
    },
    commentDialog: {
      title: 'Opmerking',
      commentLabel: 'Opmerking',
      commentPlaceholder: 'voorbeeldtekst',
      createdBy: 'Gemaakt door',
      updatedDate: 'Bijgewerkt op',
      updatedBy: 'Bijgewerkt door',
      documents: 'Documenten',
      delete: 'verwijderen',
      cancel: 'annuleren',
      save: 'opslaan',
      successMessage: 'Opmerking succesvol bijgewerkt',
      confirmDeleteAttachment: 'Weet u zeker dat u deze bijlage wilt verwijderen?',
      confirmDeleteAttachmentHeader: 'Bijlage verwijderen',
      commentRequired: 'Opmerking is verplicht',
      addComment: 'Opmerking Toevoegen',
      editComment: 'Opmerking Bewerken',
      confirmDelete: 'Weet u zeker dat u deze opmerking wilt verwijderen?',
      confirmDeleteHeader: 'Opmerking Verwijderen',
      commentAdded: 'Opmerking succesvol toegevoegd',
      commentUpdated: 'Opmerking succesvol bijgewerkt',
      commentDeleted: 'Opmerking succesvol verwijderd',
    },
    confirmDeleteHeader: 'Verwijderen bevestigen',
    confirmDeleteMessage: 'U staat op het punt dit item te verwijderen. Wilt u doorgaan?',
    confirmDeleteComment: 'Weet u zeker dat u deze opmerking wilt verwijderen?',
    commentDeletedSuccess: 'Opmerking succesvol verwijderd',
    changeStatusHeader: 'Bevestig Statuswijziging',
    confirmChangeStatus: 'Wilt u de status wijzigen?',
    confirmReturnToTeamLead: 'Wilt u deze PSSR teruggeven aan de teamleider?',
    confirmRejectHeader: 'Afwijzing bevestigen',
    confirmRejectMessage: 'Weet u zeker dat u deze PSSR wilt afwijzen?',
    confirmReopenHeader: ' ',
    confirmReopenMessage: 'Weet u zeker dat u deze PSSR opnieuw wilt openen?',
    comments: {
      title: 'Opmerkingen',
      addComment: 'opmerking toevoegen',
      noComments: 'Geen opmerkingen toegevoegd',
      by: 'door',
      on: 'op',
    },
    validation: {
      onlyPSSRTeamLeadcanInitiatePSSR: 'Alleen PSSR-teamleider en Definitieve Fiatteur kunnen PSSR initiëren',
      requireFinalApproverBeforeInitiation:
        'Indien aangevinkt, heeft de PSSR een Definitieve Fiatteur nodig om dit in gang te zetten',
      pssrMustAnswerAllQuestionsToCompleteWalkdown: 'Vul alle vragen & handtekeningen in om de inspectie te voltooien',
      pssrMustHaveFinalApproverToCompleteWalkdown:
        'PSSR moet een Definitieve Fiatteur hebben om de inspectieronde af te ronden',
      onlyPSSRTeamLeadcanSubmitforPendingApproval: 'Alleen PSSR-teamleider kan dit indienen voor Goedkeuring',
      p3ActionItemsMustBeClosed: 'Actiepunten P3 moeten worden afgesloten',
      p4ActionItemsMustBeClosed: 'Actiepunten P4 moeten worden afgesloten',
      onlyFinalApprovercanApprovePSSR: 'Alleen Definitieve Fiatteur kan PSSR goedkeuren',
      onlyPSSRTeamLeadClosePSSR: 'Alleen PSSR-teamleider kan PSSR afsluiten',
    },
  },
  pdfDialog: {
    header: 'PDF-bestand bijvoegen',
    selectTypePrompt: 'Hoe wilt u deze PDF bijvoegen?',
    document: 'Document',
    image: 'Afbeelding',
    selectPagesTitle: 'Selecteer de pagina\'s om te converteren naar afbeeldingen',
    allPages: 'Alle pagina\'s',
    selectPages: 'Pagina\'s selecteren',
    page: 'Pagina',
    select: 'Selecteren',
    couldNotDetectPages: 'Kon het aantal pagina\'s niet detecteren. Alle pagina\'s worden opgenomen.',
  },
  attachmentUpload: {
    title: 'Bestand Bijvoegen',
    selectType: 'Wat wilt u bijvoegen?',
    types: {
      link: 'Link',
      document: 'Document',
      image: 'Afbeelding',
    },
    forms: {
      url: 'URL',
      urlPlaceholder: 'https://voorbeeld.com',
    },
    clickToSelect: 'Klik om een bestand te selecteren',
    acceptedImageTypes: 'Geaccepteerde formaten: JPG, PNG, GIF, etc.',
    acceptedDocumentTypes: 'Geaccepteerde formaten: PDF, DOC, DOCX, XLS, XLSX',
    upload: 'Uploaden',
    successMessage: 'Bestand succesvol bijgevoegd',
    sections: {
      images: 'Afbeeldingen',
      documents: 'Documenten',
      links: 'Links',
    },
    uploaded: 'Geüpload',
    download: 'Downloaden',
  },
  organizationsList: {
    title: 'Organisaties',
    tableHeader: 'organisatie',
    noOrganizations: 'Geen organisaties beschikbaar',
    successCreated: 'Organisatie succesvol aangemaakt',
    actions: {
      addNew: 'nieuwe organisatie toevoegen',
    },
    forms: {
      name: 'Organisatienaam',
      namePlaceholder: 'type organisatienaam',
    },
    dialogs: {
      addNew: 'Nieuwe organisatie toevoegen',
      edit: 'Organisatie bewerken',
      deleteHeader: 'Organisatie verwijderen',
      deleteMessage: 'Weet u zeker dat u de organisatie wilt verwijderen: [{{name}}]?',
    },
  },
  userGroupsList: {
    title: 'Gebruikersgroepen voor actie-items',
    groupsSection: 'Groepen',
    noUsers: 'Geen gebruikers in deze groep',
    noGroups: 'Geen groepen beschikbaar',
    selectGroup: 'Selecteer een groep om gebruikers te bekijken',
    actions: {
      create: 'maken',
      addNewUser: 'nieuwe gebruiker toevoegen',
      selectUser: 'Gebruiker selecteren',
      changeUser: 'Gebruiker wijzigen',
      add: 'Toevoegen',
    },
    table: {
      userName: 'gebruikersnaam',
      email: 'e-mail',
    },
    forms: {
      namePlaceholder: 'Voer groepsnaam in',
      selectUserPrompt: 'Selecteer een gebruiker om aan deze groep toe te voegen',
      selectedUser: 'Geselecteerde gebruiker',
    },
    dialogs: {
      addGroup: 'Nieuwe groep toevoegen',
      editGroup: 'Groep bewerken',
      deleteGroupHeader: 'Groep verwijderen',
      deleteGroupMessage: 'Weet u zeker dat u de groep wilt verwijderen: [{{name}}]?',
      removeUserHeader: 'Gebruiker verwijderen',
      removeUserMessage: 'Weet u zeker dat u {{name}} uit deze groep wilt verwijderen?',
      addUser: 'Gebruiker aan groep toevoegen',
      selectUser: 'Gebruiker selecteren',
    },
  },
  participants: {
    title: 'Deelnemers',
    addParticipant: 'deelnemer toevoegen',
    addMember: 'Lid toevoegen',
    pssrTeamLead: '{{pssrTitle}} Teamleider',
    pssrTeam: '{{pssrTitle}} Team',
    projectManagers: 'Projectmanagers',
    projectTeamMembers: 'Projectteamleden',
    operationsRepresentative: 'Vertegenwoordiger Operaties',
    finalApprover: 'Definitieve Goedkeurder',
    actionItemAssignee: 'Actiepunt Toegewezene',
    noParticipantsAdded: 'Geen deelnemers toegevoegd',
    signedBy: 'ondertekend door',
    signedInBehalfOf: 'ondertekend namens',
    signedOn: 'ondertekend op',
  },
  qaqcImport: {
    title: 'QAQC Import',
    milestone: 'QAQC Mijlpaal',
    workOrders: 'QAQC Werkorders',
    milestoneWorkOrders: 'QAQC Mijlpaal Werkorders (optioneel)',
    milestoneWorkOrdersLabel: 'QAQC Mijlpaal Werkorders',
    milestoneWorkOrdersMessage: 'Selecteer 1 mijlpaal om werkorders binnen die mijlpaal te bekijken',
    noItemsAvailable: 'Geen beschikbare mijlpalen/werkorders van QAQC',
    noWorkOrdersForMilestone: 'Geen werkorders beschikbaar voor deze mijlpaal',
    unableLoadItems: 'QAQC-systeem niet bereikbaar voor mijlpalen/werkorders, probeer het later opnieuw',
    loadEventsError: 'Fout bij het ophalen van {{eventLabel}} vanuit QAQC',
    multipleMilestonesWarning: 'Selecteer 1 mijlpaal om de werkorders binnen die mijlpaal te zien',
    generatePssrTitle: 'PSSR-titel genereren',
    alreadyExists: 'Dit QAQC-evenement bestaat al als project',
    selectEvent: 'Project',
    sections: 'Secties',
    assignSectionLeads: 'Sectie verantwoordelijken toewijzen',
    selectLead: 'Verantwoordelijke Selecteren',
    sectionName: 'Sectienaam',
    lead: 'Verantwoordelijke',
    template: 'Sjabloon',
    type: 'Type',
    projectType: 'Project Type',
    successMessage: 'QAQC Import succesvol voltooid. Project en PSSRs aangemaakt.',
    errorMessage: 'Fout bij aanmaken QAQC project. Probeer opnieuw.',
    projectCreatedWithoutItems:
      'Project aangemaakt. QAQC heeft nog geen mijlpalen of werkorders; gebruik "Nieuwe QAQC-items laden" zodra ze beschikbaar zijn.',
    partialErrorMessage:
      'Het project is aangemaakt, maar de bijbehorende PSSR\'s konden niet worden aangemaakt. Gebruik "Nieuwe QAQC-items laden" om het opnieuw te proberen.',
    somePssrsNotCreated:
      'Slechts {{created}} van {{total}} PSSR\'s zijn aangemaakt. Gebruik "Nieuwe QAQC-items laden" om de rest aan te maken.',
  },
  participantDialog: {
    title: 'Selecteer deelnemer',
    addParticipant: 'Deelnemer Toevoegen',
    selectUserType: 'Selecteer Gebruikerstype',
    selectedUserType: 'Geselecteerd Gebruikerstype',
    chevronDirectory: 'chevron directory/gedeelde gebruikers',
    newNonChevron: 'nieuwe niet-chevron',
    searchPlaceholder: 'Zoeken op e-mail...',
    emailPlaceholder: 'Voer e-mail in...',
    namePlaceholder: 'Voer naam in...',
    selectRole: 'Selecteer rol',
    selectedRole: 'Geselecteerde Rol',
    selectOne: 'selecteer een',
    add: 'toevoegen',
    successMessage: 'Deelnemer succesvol toegevoegd',
    added: 'Deelnemer succesvol toegevoegd',
    addError: 'Fout bij toevoegen deelnemer',
    alreadyParticipantPssr: 'Deze gebruiker is al een deelnemer van deze PSSR als {{role}}',
    alreadyMemberProject: 'Deze gebruiker is al een lid van dit project als {{role}}',
    stagedParticipants: 'toe te voegen:',
    batchLimitReached: 'limiet van {{limit}} gebruikers bereikt, selecteer toevoegen',
    alreadyStagedError: 'deze gebruiker staat al in de lijst',
  },
  participantEditDialog: {
    title: 'Deelnemer bewerken',
    user: 'Gebruiker',
    selectRole: 'Rol selecteren',
    delete: 'verwijderen',
    captureSignature: 'handtekening vastleggen',
    recaptureSignature: 'handtekening opnieuw vastleggen',
    removeSignature: 'handtekening verwijderen',
    removeSignatureSuccess: 'Handtekening succesvol verwijderd',
    save: 'opslaan',
    noSignature: 'Geen handtekening vastgelegd',
    successMessage: 'Deelnemer succesvol bijgewerkt',
    deleteSuccessMessage: 'Deelnemer succesvol verwijderd',
    deleteConfirmHeader: 'Deelnemer verwijderen',
    deleteConfirmMessage: 'Weet u zeker dat u deze deelnemer wilt verwijderen?',
  },
  buAdminsList: {
    title: 'BU Beheerders',
    actions: {
      addNewUser: 'beheerder toevoegen',
      delete: 'verwijderen',
    },
    table: {
      fullName: 'volledige naam',
      email: 'e-mail',
    },
    noAdmins: 'Geen beheerdersgebruikers beschikbaar',
  },
  externalUserForm: {
    labels: {
      firstName: 'Voornaam',
      lastName: 'Achternaam',
      email: 'E-mail',
      userNameEmail: 'Gebruikersnaam of e-mail',
    },
  },
  sharedUserForm: {
    labels: {
      sharedUserGroup: 'Gedeelde gebruikersgroep',
      sharedEmail: 'Gedeeld e-mailadres',
    },
    actions: {
      addChildUser: 'gebruiker toevoegen',
      importSharedUsers: 'Gedeelde gebruikers importeren',
    },
    whitePages: {
      title: 'White Pages Integratie',
      description:
        'Gebruik dit type gedeeld e-mailadres als u moet synchroniseren met White Pages. De lijst met gebruikers wordt automatisch bijgewerkt. Sommige gebruikers kunnen automatisch worden toegevoegd of verwijderd uit dit gedeelde e-mailadres.',
    },
    customConfiguration: {
      title: 'Aangepaste configuratie',
      description: 'Beheer de lijst met gebruikers handmatig.',
    },
  },
  pssrsList: {
    title: 'PSSR',
    location: 'Locatie',
    details: 'Details',
    emptyMessage: 'Geen PSSRs gevonden',
    searchByLocation: 'Locatie',
    searchByDetails: 'Details',
    filters: {
      businessUnit: 'Bedrijfsunit',
      organization: 'Organisatie',
      area: 'Gebied',
      subArea: 'Sub Gebied',
      facilityOperationTeam: 'Faciliteit Operatieteam',
      facility: 'Faciliteit',
      project: 'Project',
      template: 'Sjabloon',
      selectOne: 'selecteer een',
      status: 'Status',
      type: 'Type',
      deletedStagnant: 'Verwijderd/Stagnant',
      showOnlyDeleted: 'toon alleen verwijderde pssrs',
      showOnlyStagnant: 'toon alleen stagnante pssrs',
      search: 'Zoeken',
      placeholderSearch: 'zoeken op moc, wo, pssr id, titel, enz...',
      userSearch: 'Gebruiker Zoeken',
      placeholderUserSearch: 'sample text',
      isStagnant: 'Is Stagnant',
      isDeleted: 'Is Verwijderd',
    },
    buttons: {
      clearFilter: 'filter wissen',
      newPssr: 'nieuwe PSSR',
      viewItems: 'items weergeven',
      open: 'openen',
    },
    actions: {
      clearFilter: 'Filter wissen',
      newPssr: 'Nieuw PSSR pre-startup veiligheidsevaluatie',
      importPssr: 'Importeren PSSRs',
    },
    table: {
      id: 'ID',
      title: 'Titel',
      type: 'Type',
      status: 'Status',
      facility: 'Faciliteit',
      project: 'Project',
    },
    statusOptions: {
      draft: 'Concept',
      initiated: 'Geïnitieerd',
      inProgress: 'In uitvoering',
      completed: 'Ingevuld',
      pendingApproval: 'In afwachting van goedkeuring',
      approved: 'Goedgekeurd',
      closed: 'Afgesloten',
    },
    noPssrs: 'Geen PSSRs beschikbaar',
  },
  pssrListItem: {
    pssrId: 'PSSR ID',
    pssr: 'PSSR',
    moc: 'MOC',
    wo: 'WO',
    project: 'Project',
    teamLeads: 'Teamleiders',
    totalQuestions: 'Totale Vragen',
    outstandingQuestions: 'Openstaande Vragen',
    completedQuestions: 'Voltooide Vragen',
    area: 'Gebied',
    subArea: 'Sub Gebied',
    facility: 'Faciliteit',
    qaqcStatus: 'QAQC-status',
    qaqcMilestone: 'QAQC-mijlpaal',
    qaqcWorkOrder: 'QAQC-werkorder',
    qaqcReady: '% gereed',
    qaqcComplete: '% voltooid',
    qaqcAccepted: '% geaccepteerd',
    qaqcSignatures: 'Handtekeningen',
    qaqcDocuments: 'QAQC-documenten',
    qaqcNoData: 'Geen QAQC-gegevens',
  },
  pssrStatuses: {
    Draft: 'Concept',
    Initiated: 'Geïnitieerd',
    InProgress: 'In uitvoering',
    Completed: 'Ingevuld',
    PendingApproval: 'In afwachting van goedkeuring',
    Approved: 'Goedgekeurd',
    Closed: 'Afgesloten',
    Deleted: 'Verwijderd',
    CreateDate: 'Concept Gemaakt op',
    InitiatedOn: 'Geïnitieerd',
    StartedOn: 'Gestart',
    CompletedOn: 'Inspectieronde Voltooid op',
    PendingApprovalOn: 'Goedkeuring Ingediend op',
    ApprovedOn: 'Goedgekeurd op',
    ClosedOn: 'Afgesloten op',
    DeletedOn: 'Verwijderd op',
    RestoredOn: 'Hersteld op',
  },
  signatureCaptureDialog: {
    title: 'Handtekening vastleggen',
    confirm: 'bevestigen',
    saveSuccess: 'Handtekening succesvol vastgelegd',
  },
  projectsList: {
    title: 'Projecten',
    table: {
      projectName: 'Projectnaam',
      projectManager: 'Projectmanager',
      status: 'Status',
      completedTotalPssrs: 'Voltooid/totaal pssrs',
      actions: 'Acties',
      dateCreated: 'Aanmaakdatum',
    },
    statusLabels: {
      active: 'actief',
      closed: 'gesloten',
    },
    sort: {
      placeholder: 'Sorteren op',
      nameAsc: 'Naam (A-Z)',
      nameDesc: 'Naam (Z-A)',
      statusAsc: 'Status (Laag naar Hoog)',
      statusDesc: 'Status (Hoog naar Laag)',
      dateAsc: 'Aanmaakdatum (Oudste Eerst)',
      dateDesc: 'Aanmaakdatum (Nieuwste Eerst)',
    },
    actions: {
      open: 'openen',
      createProject: 'project aanmaken',
    },
    projectSearch: 'Project zoeken',
    showDeletedProjects: 'Verwijderde projecten tonen',
    searchPlaceholder: 'Zoeken op naam',
    datePlaceholder: 'mm/dd/jjjj - mm/dd/jjjj',
    statusPlaceholder: 'selecteer een',
    noProjects: 'Geen projecten beschikbaar',
  },
  projectEdit: {
    title: 'Project Bewerken',
    projectName: 'Projectnaam',
    projectNamePlaceholder: 'Voer projectnaam in',
    statusActive: 'actief',
    statusClosed: 'gesloten',
    statusDeleted: 'verwijderd',
    teamMembers: 'Teamleden',
    addParticipant: 'deelnemer toevoegen',
    pssrCcc: 'PSSR/CCC',
    newPssr: 'Nieuwe {{pssrTitle}}',
    noPssrCcc: 'Er zijn geen PSSR/CCC\'s gekoppeld aan dit project.',
    delete: 'verwijderen',
    markAsClosed: 'markeren als gesloten',
    reopen: 'heropenen',
    confirmDelete: 'Weet u zeker dat u dit project wilt verwijderen?',
    confirmDeleteHeader: 'Verwijdering Bevestigen',
    confirmDeletePssrs: 'Wilt u ook alle PSSR\'s die aan dit project zijn gekoppeld verwijderen?',
    confirmDeletePssrsHeader: 'PSSR\'s Verwijderen?',
    deleteSuccess: 'Project succesvol verwijderd',
    confirmMarkAsClosed: 'Weet u zeker dat u dit project als gesloten wilt markeren?',
    confirmMarkAsClosedHeader: 'Bevestig Markeren als Gesloten',
    markedAsClosedSuccess: 'Project succesvol gemarkeerd als gesloten',
    confirmCloseProjectTitle: 'Bevestig Project Sluiten',
    confirmCloseProjectDescription: 'Weet u zeker dat u dit project als gesloten wilt markeren?',
    confirmReopenProjectTitle: 'Bevestig Project Heropenen',
    confirmReopenProjectDescription: 'Weet u zeker dat u dit project wilt heropenen?',
    cannotCloseProjectDueOpenPSSRs: 'Het project kan niet worden gesloten omdat er open PSSRs zijn.',
    projectUpdatedSuccessfully: 'Project succesvol bijgewerkt',
    loadNewQaqcItems: 'Nieuwe QAQC-items laden',
    qaqcItemsLoadedSuccessfully: 'Nieuwe QAQC-items zijn succesvol geladen',
    qaqcItemsUpToDate: 'QAQC-items zijn al up-to-date',
    qaqcInputWarning: 'Vul de vereiste QAQC-velden in voordat u nieuwe items laadt: {{fields}}.',
    initiateAll: 'Alle PSSR\'s initiëren',
    initiateAllTitle: 'Alle PSSR\'s initiëren',
    initiateAllDescription: 'Wilt u alle PSSR\'s van dit project initiëren?',
    initiateAllSuccess: 'Alle PSSR\'s zijn succesvol geïnitieerd',
    initiateAllPartialError: 'Sommige PSSR\'s konden niet worden geïnitieerd:',
    projectReopenedSuccessfully: 'Project succesvol heropend',
    restorePssr: 'Herstellen',
    confirmRestoreProject: 'Weet u zeker dat u dit project wilt herstellen?',
    confirmRestoreProjectHeader: 'Bevestig Herstellen',
    restoreSuccess: 'Project succesvol hersteld',
    deleteDialog: {
      title: 'Bevestig verwijderen Project',
      confirmDeleteWithPssrs:
        'De volgende actie zou het Project en de bijbehorende PSSRs kunnen verwijderen. Wil je verder gaan?',
      confirmDeleteWithoutPssrs: 'Wil je verder gaan?',
      deleteProjectAndPssrs: 'Project en PSSRs verwijderen',
      deleteProjectOnly: 'Alleen Project verwijderen',
      deleteSuccess: 'Project succesvol verwijderd',
      deleteError: 'Fout bij het verwijderen van project',
    },
    cascadeDialog: {
      cascade: 'cascade',
      title: 'Rollen Cascaderen',
      description: 'Selecteer de deelnemers die u wilt cascaderen naar alle PSSR\'s voor dit project.',
      teamLeads: 'Teamleiders',
      teamMembers: 'Teamleden',
      operationsRepresentative: 'Operationele Vertegenwoordiger',
      finalApprover: 'Definitieve Goedkeurder',
      apply: 'toepassen',
      success: 'Rollen succesvol gecascadeerd',
    },
    errors: {
      noPermissionToEditParticipants: 'U heeft geen toestemming om deelnemers in dit project te bewerken',
    },
  },
  multiselect: {
    selectedItems: '{0} items geselecteerd',
    placeholder: 'kiezen',
  },
  support: {
    title: 'Feedback',
    buSupportInfo: 'ePSSR BU Ondersteuningsinformatie',
    serviceNowInstructions: 'ePSSR Service Now Ticketing Instructies',
    instructions: {
      step1:
        'Ga naar het <a class="support-link" href="https://chevron.service-now.com/mychevron?id=sc_cat_item_guide&sys_id=9c08a21edb126450182e1dca48961981&sysparm_u_appid=1500000886" target="_blank" rel="noopener">Applicatie Ondersteuningsverzoek</a> formulier in het Chevron IT Service Portal',
      step1LinkText: 'Applicatie Ondersteuningsverzoek',
      step2: 'Selecteer onder het Applicatie veld <b>Mobile PSSR</b>.',
      step3:
        'Om een probleem of bug te melden, selecteer <b>Een probleem melden</b>. Om een verbeteringsverzoek of gebruikerstoegangsverzoek in te dienen, selecteer <b>Serviceverzoek</b>. Klik op Volgende.',
    },
    reportIssue: {
      title: 'Een probleem melden',
      step1: 'Vul de Beschrijving van het Probleem, Impact en Urgentie in.',
      step2: 'Druk op Volgende en vervolgens Verzenden.',
      step3:
        'Het ePSSR Ondersteuningsteam zal de ontvangst van het ticket binnen 24 uur tijdens kantooruren bevestigen.',
    },
    enhancement: {
      title: 'Verbeteringsverzoek',
      step1: 'Selecteer <b>Verbeteringen</b> onder Type Verzoeken.',
      step2: 'Selecteer Prioriteit (<b>Laag, Gemiddeld, Hoog</b>)',
      step3: 'Vul de Beschrijving van het Verzoek in',
      step4: 'Selecteer Volgende en Verzenden.',
      step5:
        'Het ePSSR Ondersteuningsteam zal verbeteringsverzoeken beoordelen als onderdeel van het Surface Digital PI Planningsproces',
    },
    userAccess: {
      title: 'Gebruikerstoegangsverzoek',
      step1: 'Selecteer <b>Toegang aanvragen</b> onder Type Verzoeken.',
      step2: 'Selecteer Type Toegangsverzoek (<b>Toevoegen of Verwijderen</b>)',
      step3: 'Selecteer een gebruiker',
      step4: 'Selecteer Prioriteit (<b>Laag, Gemiddeld, Hoog</b>)',
      step5: 'Specificeer de Rol en Toegang die de Gebruiker nodig heeft.',
      step6: 'Selecteer Volgende en Verzenden.',
      step7:
        'Het ePSSR Ondersteuningsteam zal de ontvangst van het ticket binnen 24 uur tijdens kantooruren bevestigen.',
    },
  },
  datepicker: {
    dayNames: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'],
    dayNamesShort: ['Zon', 'Maa', 'Din', 'Woe', 'Don', 'Vri', 'Zat'],
    dayNamesMin: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
    monthNames: [
      'Januari',
      'Februari',
      'Maart',
      'April',
      'Mei',
      'Juni',
      'Juli',
      'Augustus',
      'September',
      'Oktober',
      'November',
      'December',
    ],
    monthNamesShort: ['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
    today: 'Vandaag',
    clear: 'Wissen',
    dateFormat: 'mm/dd/yy',
    weekHeader: 'Wk',
  },
  errors: {
    unauthorized: {
      title: 'Ongeautoriseerde toegang',
      message: 'U heeft geen toestemming om deze pagina te openen.',
    },
    serverError: {
      title: 'Serverfout',
      message: 'Er is een onverwachte fout opgetreden. Probeer het later opnieuw.',
    },
    pageNotFound: {
      title: 'Pagina niet gevonden',
      message: 'De pagina die u zoekt bestaat niet.',
    },
    actions: {
      returnHome: 'Terug naar home',
    },
  },
  attachments: {
    sections: {
      images: 'Afbeeldingen',
      documents: 'Documenten',
      links: 'Links',
    },
    actions: {
      download: 'Downloaden',
      delete: 'Verwijderen',
    },
    labels: {
      uploaded: 'Geüpload',
    },
  },
  imagePreview: {
    errorMessage: 'Kan afbeelding niet laden',
    errorDetails: 'Controleer de browserconsole voor details',
  },
  functionalReview: {
    audit: {
      createdBy: 'Gemaakt door',
      updatedDate: 'Bijgewerkt op',
      updatedBy: 'Bijgewerkt door',
    },
  },
  checklistItem: {
    toolbar: {
      bold: 'Vet',
      italic: 'Cursief',
      underline: 'Onderstrepen',
      orderedList: 'Genummerde lijst',
      unorderedList: 'Ongenummerde lijst',
      codeBlock: 'Codeblok',
      blockQuote: 'Blokcitaat',
    },
    alignment: {
      center: 'gecentreerd',
      right: 'rechts',
      justify: 'uitgevuld',
    },
  },
  pssrSections: {
    actions: {
      removeUser: 'Gebruiker verwijderen',
    },
  },
  pssrParticipantsSections: {
    actions: {
      remove: 'Verwijderen',
    },
  },
  progressBar: {
    label: 'Voortgang:',
  },
  categories: {
    dialogs: {
      addCategory: 'Categorie toevoegen',
      editCategory: 'Categorie bewerken',
      createSubCategory: 'Nieuwe subcategorie maken',
      editSubCategory: 'Subcategorie bewerken',
    },
    placeholders: {
      subcategoryName: 'Naam subcategorie',
    },
  },
  categoriesList: {
    title: 'Categorieën',
    hideInactiveItems: 'Inactieve items verbergen',
    subCategoryName: 'Subcategorienaam',
    inactive: '(inactief)',
    noSubcategories: 'Geen subcategorieën',
    selectHeader: 'Selecteren',
    actions: {
      createSubCategory: 'Nieuwe subcategorie aanmaken',
      restore: 'Herstellen',
      add: 'Toevoegen',
      addSubCategories: 'Subcategorieën toevoegen',
      remove: 'Verwijderen',
    },
    deleteDisabledTooltip: 'Deze categorie kan niet worden verwijderd omdat deze actieve subcategorieën bevat',
    dialogs: {
      addSubCategoriesHeader: 'Subcategorieën toevoegen',
      deleteCategoryHeader: 'Let op',
      deleteCategoryMessage: 'Weet u zeker dat u de Categorie wilt verwijderen: [{{name}}]?',
      deleteSubCategoryHeader: 'Let op',
      deleteSubCategoryMessage: '[{{name}}] verwijderen uit categorie [{{category}}]? De subcategorie zelf wordt niet verwijderd.',
    },
    validation: {
      subCategoryExists: 'Er bestaat al een subcategorie met deze naam',
      categoryExists: 'Er bestaat al een categorie met deze naam',
    },
  },
};
export default nl;
